var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { staticClass: "root" },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                  ]),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Dossier verwijderen",
                              expression: "'Dossier verwijderen'",
                            },
                          ],
                          attrs: { disabled: _vm.deleteDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.deleteDossier()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _vm.isFetching ? _c("app-fetching-spinner-overlay") : _vm._e(),
              _c("w-data-table", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "calc(100vh - 185px)",
                },
                attrs: {
                  items: _vm.dossiers,
                  columns: _vm.columns,
                  "selected-items": _vm.selectedItems,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }